<script>
    export default {
        methods: {
            parseLocalDateTime(localDateTimeArr) {
                return new Date(localDateTimeArr[0], localDateTimeArr[1], localDateTimeArr[2], localDateTimeArr[3], localDateTimeArr[4], 0, 0);
            },
            isNotZeroAndEmpty(param) {
                return (param && param > 0);
            },
            fileResourceUrl: file => {
                // Handle object (ArticleFileDTO from backend)
                if (typeof file === 'object' && file !== null) {
                    // If it has mediaUrl (CMS-managed media), use that
                    if (file.mediaUrl) {
                        return process.env.VUE_APP_API_URL + file.mediaUrl;
                    }
                    // Regular file object: extract fileName property
                    return process.env.VUE_APP_API_URL + '/public/images/' + file.fileName;
                }
                // Backward compatibility: plain string filename
                return process.env.VUE_APP_API_URL + '/public/images/' + file;
            },
            imageResource : (file, size, extension) => encodeURI(process.env.VUE_APP_API_URL + '/public/file/?filename=' + file + (size ? '&size=' + size : '') + (extension ? '&targetExtension=' + extension : '')) ,
            articleImageResource : (file, size, extension) => encodeURI(process.env.VUE_APP_API_URL + '/public/file/article/?filename=' + file + (size ? '&size=' + size : '') + (extension ? '&targetExtension=' + extension : '')) ,

            viewportExceeding: (el, viewport) => {
                // Get element's bounding
                var bounding = el.getBoundingClientRect();

                // Check if it's out of the viewport on each side
                var out = {};
                out.exceedingTop = bounding.top < 0;
                out.exceedingLeft = bounding.left < 0;
                out.exceedingBottom = bounding.bottom > (viewport.offsetHeight || viewport.scrollHeight);
                out.exceedingRight = bounding.right > (viewport.offsetWidth || viewport.scrollWidth);
                out.exceedingAny = out.exceedingTop || out.exceedingLeft || out.exceedingBottom || out.exceedingRight;
                out.exceedingAll = out.exceedingTop && out.exceedingLeft && out.exceedingBottom && out.exceedingRight;

                return out;
            },
            getObjectFitSize: (contains /* true = contain, false = cover */, containerWidth, containerHeight, width, height) => {
                var doRatio = width / height;
                var cRatio = containerWidth / containerHeight;
                var targetWidth = 0;
                var targetHeight = 0;
                var test = contains ? (doRatio > cRatio) : (doRatio < cRatio);

                if (test) {
                    targetWidth = containerWidth;
                    targetHeight = targetWidth / doRatio;
                } else {
                    targetHeight = containerHeight;
                    targetWidth = targetHeight * doRatio;
                }

                return {
                    width: targetWidth,
                    height: targetHeight,
                    x: (containerWidth - targetWidth) / 2,
                    y: (containerHeight - targetHeight) / 2
                };
            }
        }
    }
</script>